import React from 'react';
import { string, object, number } from 'yup';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '../../config';
import SelectAllBtn from '~/commons/components/SelectAllBtn.jsx';

const schema = object({
  title: string().required(),
  order: number(),
//   path: string().required(),
});

const defaults = {
  title: '',
  coverImg: null,
  content: '',

  publishAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '08:00',
  },
  expiresAt: '',
  order: '',
};

const spliceIntoChunks = (arr, chunkSize) => {
  const res = [];
  while (arr.length > 0) {
    const chunk = arr.splice(0, chunkSize);
    res.push(chunk);
  }
  return res;
};

const FormShare = ({
  share,
}) => {
  const { t, i18n: { language } } = useTranslation();
  return (
  <FormResource
    {...{
      defaults,
      schema,
      stored: share ? {
        ...share,
        // publishAt: {
        //   date: moment(ann.publishAt).format('YYYY-MM-DD'),
        //   time: moment(ann.publishAt).format('HH:mm'),
        // },
        // expiresAt: share.expiresAt
        //   ? moment(share.expiresAt).format('YYYY-MM-DD')
        //   : '',
        order: share.order ? share.order : '',
      } : undefined,
      api: '/api/site/shares',
      onSubmit: (vs) => ({
        ...vs,
        coverImg: typeof vs.coverImg === 'string'
          ? vs.coverImg : '',
        // publishAt: moment(
        //   `${vs.publishAt.date} ${vs.publishAt.time}`,
        //   'YYYY-MM-DD HH:mm',
        // ).toDate(),
        // expiresAt: vs.expiresAt
        //   ? moment(vs.expiresAt).endOf('d').toDate()
        //   : null,
      }),
    }}
  >
    <div className="form-row">
      <div className="col-auto">
        <FormGroup name="order" label={t('Order')} />
      </div>
    </div>
    <FormGroup name="title" label={t('Title')} />
    {/* <FormGroup name="path" as="select" label={t('Path')}>
      <option value="home">home</option>
      <option value="app">app</option>
    </FormGroup> */}
    <FormGroup
      name="coverImg"
      as="coverImg"
      api="/api/site/view-slots/files"
      label={t('Cover Image')}
    />
    <FormGroup
      name="content"
      as="summernote"
      fileUploadUrl="/api/site/view-slots/files"
      label={t('Content')}
    />
  </FormResource>
  );
};

export default FormShare;
